<template>
  <div class="bg-gray-100 rounded-t-lg p-5 border-b border-gray-300">
    <p class="text-md font-semibold text-gray-800">Filters - {{ selectedCount }} selected</p>
  </div>

  <div class="flex h-96">
    <div class="w-1/3 border-r border-gray-300">
      <ul>
        <li
          v-for="(tab, index) in filterTabs"
          :key="index"
          @click="activeTab = index"
          class="cursor-pointer p-5 text-md font-medium transition border-b border-gray-200"
          :class="{
            'text-primary font-semibold bg-white': activeTab === index,
            'text-gray-600 bg-gray-100': activeTab !== index
          }"
        >
          {{ tab.label }}
        </li>
      </ul>
    </div>
    <div class="w-2/3 pl-4 space-y-3 overflow-y-auto max-h-96 scrollbar-hide">
      <div v-if="activeTab === 0">
        <ul>
          <li v-for="(option, i) in filterByDate" :key="i" class="flex items-center space-x-2 border-b border-gray-100">
            <URadio
              v-model="selectedFilters.date"
              :value="option"
              :name="'date-filter'"
            />
            <span class="text-gray-700 text-sm p-4">{{ option }}</span>
          </li>
        </ul>
      </div>

      <div v-if="activeTab === 1">
      <ul>
        <li v-for="(option, i) in giftCardsStatus" :key="i" class="flex items-center space-x-2 border-b border-gray-100">
          <URadio 
            :model-value="selectedFilters.status[0]" 
            :value="option" 
            :name="'status-filter'" 
            @change="selectedFilters.status = [option]" 
          />
          <span class="text-gray-700 text-sm p-4">{{ option }}</span>
        </li>
      </ul>
    </div>

      <div v-if="activeTab === 2">
        <div class="flex items-center space-x-2 py-4 border-b border-gray-300">
          <UCheckbox v-model="selectAllCategory" :value="true" @change="toggleSelectAll('category', categoryOptions)" />
          <span class="text-gray-700">Select All</span>
        </div>
        <ul>
          <li v-for="(option, i) in categoryOptions" :key="i" class="flex items-center space-x-2 border-b border-gray-100">
            <UCheckbox v-model="selectedFilters.category" :value="option" />
            <span class="text-gray-700 text-sm p-4">{{ option }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="shadow-2xl rounded-b-lg p-4">
    <div class="flex justify-between mt-4">
      <UButton color="white" variant="ghost" class="md:w-2/5 w-5/12 text-nowrap text-primary" @click="clearFilters"
        label="Clear Filters" />
      <UButton label="Show Results" class="md:w-2/5 w-5/12 ml-2" @click="applyFilters" />
    </div>
  </div>
</template>


<script setup>
const dayjs = useDayjs();
const activeTab = ref(0);
const giftcart = useGiftCart();
const emit = defineEmits(["success"]);
const selectedFilters = ref({
  date: giftcart.filter.date, 
  status: giftcart.filter.status,
  category: giftcart.filter.category
});

const filterTabs = [
  { label: "Filter by Date" },
  { label: "GiftCards Status" },
  { label: "Category" }
];

const filterByDate = ["All", "Current Month", "Last 3 Months", "Last 6 Months"];
const giftCardsStatus = ["Completed","In progress", "Failed"];
const categoryOptions = [ "Food", "Shopping", "Electronics", "Travel", "Gift and Donation"];

const selectAllStatus = ref(false);
const selectAllCategory = ref(false);

const selectedCount = computed(() => {
  let count = 0;
  if (selectedFilters.value.date) count += 1;
  count += selectedFilters.value.status.length;
  count += selectedFilters.value.category.length;
  return count;
});

const toggleSelectAll = (type, options) => {
  if (type === 'status') {
    selectedFilters.value.status = selectAllStatus.value ? [...giftCardsStatus] : [];
  } else if (type === 'category') {
    selectedFilters.value.category = selectAllCategory.value ? [...categoryOptions] : [];
  }
};

const clearFilters = () => {
  selectedFilters.value = { date: "", status: [], category: [] }; 
  selectAllStatus.value = false;
  selectAllCategory.value = false;
};

const applyFilters = () => {
  const today = dayjs();
//   order.addFilter(selectedFilters.value);
  if (selectedFilters.value.date === "Current Month") {
    selectedFilters.value.date = today.startOf("month").format("YYYY-MM-DD");
  } else if (selectedFilters.value.date === "Last 3 Months") {
    selectedFilters.value.date = today.subtract(3, "month").startOf("month").format("YYYY-MM-DD");
  } else if (selectedFilters.value.date === "Last 6 Months") {
    selectedFilters.value.date = today.subtract(6, "month").startOf("month").format("YYYY-MM-DD");
  } else {
    selectedFilters.value.date = "";
  }

  console.log("Selected Filters:", selectedFilters.value);
  emit("success", selectedFilters.value);
};
</script>
